(function () {
  const VARIANT_ID = 54852027220344;
  const BOTTLE_PRODUCT_IDS = [8915580551423];
  const BOTTLE_HANDLES = ['hydrobottle-pro'];
  const ADDON_PRODUCTS = [
    {
      productId: 15029687648632,
      variantId: 55566986674552,
      handle: '3-ars-forsikring',
      title: '3 års HydroBottle Forsikring',
      badge: '',
      description: 'Dækker uheld, fejl og ombytning.',
      buttonLabel: 'Tilføj'
    }
  ];
  const OLD_SELECTOR = '[data-cart-protection-toggle]';
  const SELECTOR = '[data-cart-protection-v2]';
  const ADDONS_SELECTOR = '[data-cart-addons-v1]';
  const STYLE_ID = 'cart-protection-v2-styles';
  const ADD_BUTTON_ICON = `
    <svg class="cart-addons-v1__button-icon" preserveAspectRatio="none" overflow="visible" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="32" height="32" rx="4" fill="#3A7DAB"/>
      <path d="M16.4797 20.5178V11.4822C16.4797 11.224 16.264 11 16.0027 11C15.7414 11 15.5203 11.224 15.5203 11.4822V20.5178C15.5203 20.776 15.7414 21 16.0027 21C16.264 21 16.4797 20.776 16.4797 20.5178ZM11.4824 16.4822H20.523C20.7813 16.4822 21 16.2611 21 16C21 15.7389 20.7813 15.5178 20.523 15.5178H11.4824C11.2187 15.5178 11 15.7389 11 16C11 16.2611 11.2187 16.4822 11.4824 16.4822Z" fill="white" stroke="white" stroke-width="0.288631"/>
    </svg>
  `;
  let timer = null;
  let addonProducts = null;
  let addonProductsLoading = null;
  let currentCart = null;
  let lastRefreshCart = null;

  const styles = `
    .cart-protection-v2 {
      width: 100%;
      margin: 0;
      padding: 0 0 12px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      position: relative;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: #1f1f1f;
      text-align: left;
      cursor: pointer;
      box-sizing: border-box;
      font-family: var(--hl-font-sans, "Geist HydroLife", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif);
      -webkit-appearance: none;
      appearance: none;
    }
    .cart-protection-v2::before { content: ""; position: absolute; left: 0; right: 0; bottom: 0; height: 1px; background: rgba(31, 31, 31, 0.12); pointer-events: none; }
    .cart-protection-v2__icon { width: 24px; height: 23px; flex: 0 0 24px; margin: 0; color: #1f1f1f; }
    .cart-protection-v2__icon svg { display: block; width: 100%; height: 100%; }
    .cart-protection-v2__text { min-width: 0; flex: 1 1 auto; display: flex; flex-direction: column; justify-content: center; gap: 2px; }
    .cart-protection-v2__title { display: block; color: #1f1f1f; font-family: inherit; font-size: 12px; font-weight: 500; line-height: 1.2; letter-spacing: 0; }
    .cart-protection-v2__description { display: block; color: rgba(31, 31, 31, 0.64); font-family: inherit; font-size: 10px; font-weight: 400; line-height: 1.25; letter-spacing: 0; }
    .cart-protection-v2__switch { position: relative; width: 18px; height: 18px; flex: 0 0 18px; border: 1.5px solid rgba(31, 31, 31, 0.55); border-radius: 4px; background: #fff; box-sizing: border-box; transition: background 0.2s ease, border-color 0.2s ease; }
    .cart-protection-v2__switch::after { content: ""; position: absolute; left: 50%; top: 50%; width: 5px; height: 9px; border: solid #fff; border-width: 0 2px 2px 0; opacity: 0; transform: translate(-50%, -58%) rotate(45deg); transition: opacity 0.2s ease; }
    .cart-protection-v2__knob { display: none; }
    .cart-protection-v2[aria-pressed="true"] .cart-protection-v2__switch { background: #1f1f1f; border-color: #1f1f1f; }
    .cart-protection-v2[aria-pressed="true"] .cart-protection-v2__switch::after { opacity: 1; }
    .cart-protection-v2.is-loading { cursor: wait; opacity: 0.65; }
    .cart-addons-v1 {
      margin: 10px 0 12px;
      padding: 12px;
      border: 1px solid rgba(37, 57, 99, 0.14);
      border-radius: 8px;
      background: #fff;
      box-sizing: border-box;
      font-family: var(--hl-font-sans, "Geist HydroLife", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif);
    }
    .hl-cart-upsells + .cart-addons-v1--inline {
      margin: 0;
      padding: 8px 12px 8px 8px;
      border: 0;
      border-radius: 8px;
      background: rgba(31, 31, 31, 0.04);
      font-family: var(--hl-font-sans, "Geist HydroLife", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif);
    }
    .opus-carousel-container .cart-addons-v1 {
      margin: 8px 0 0 !important;
      padding: 10px !important;
      border: 0 !important;
      border-radius: 8px !important;
      background: #fff !important;
    }
    .opus-carousel-container[hidden],
    .hl-cart-upsells[hidden] { display: none !important; }
    #cart-drawer-container .cd-product-list > .cd-product-item,
    #cart-drawer-container .opus-carousel-container .opus-carousel-item > .cd-carousel-product {
      background: #fff !important;
      border-radius: 8px !important;
      box-shadow: none !important;
    }
    .cart-addons-v1__title {
      margin: 0 0 9px;
      color: #000;
      font-size: 15px;
      font-weight: 800;
      line-height: 1.2;
    }
    .cart-addons-v1--inline .cart-addons-v1__title { display: none; }
    .cart-addons-v1__item {
      display: grid;
      grid-template-columns: 58px minmax(0, 1fr);
      gap: 10px;
      align-items: center;
    }
    .cart-addons-v1--inline .cart-addons-v1__item {
      padding: 0;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__item {
      grid-template-columns: 48px minmax(0, 1fr) 40px;
      column-gap: 8px;
      row-gap: 2px;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__content,
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__row {
      display: contents;
    }
    .cart-addons-v1__image {
      width: 58px;
      height: 58px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      object-fit: cover;
      background: #f5f6f7;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__image {
      grid-column: 1;
      grid-row: 1 / 4;
      align-self: center;
      width: 48px;
      height: 48px;
      border: 0;
      border-radius: 6px;
    }
    .cart-addons-v1__content { min-width: 0; }
    .cart-addons-v1__heading {
      display: flex;
      gap: 6px;
      align-items: baseline;
      flex-wrap: wrap;
      margin-bottom: 2px;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__heading {
      grid-column: 2;
      grid-row: 1;
      align-self: end;
      margin: 0;
    }
    .cart-addons-v1__name {
      color: #000;
      font-size: 13px;
      font-weight: 800;
      line-height: 1.2;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__name {
      color: #1f1f1f;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.2;
      letter-spacing: 0.01em;
      white-space: nowrap;
    }
    .cart-addons-v1__badge {
      color: #3f774f;
      font-size: 11px;
      font-weight: 800;
      line-height: 1.2;
      white-space: nowrap;
    }
    .cart-addons-v1__description {
      margin: 0 0 6px;
      color: #596170;
      font-size: 11.5px;
      line-height: 1.28;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__description {
      grid-column: 2;
      grid-row: 2;
      margin: 0;
      color: rgba(31, 31, 31, 0.64);
      font-size: 10px;
      line-height: 1.15;
      letter-spacing: 0;
    }
    .cart-addons-v1__row {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: space-between;
    }
    .cart-addons-v1__price {
      color: #000;
      font-size: 13px;
      font-weight: 800;
      white-space: nowrap;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__price {
      grid-column: 2;
      grid-row: 3;
      align-self: start;
      color: #1f1f1f;
      font-size: 12px;
      font-weight: 400;
      line-height: 1;
    }
    .cart-addons-v1__compare {
      margin-left: 4px;
      color: #777;
      font-weight: 600;
      text-decoration: line-through;
    }
    .cart-addons-v1__button {
      min-width: 76px;
      min-height: 34px;
      padding: 8px 14px;
      border: 0;
      border-radius: 7px;
      background: #0b82bf;
      color: #fff;
      font-size: 13px;
      font-weight: 800;
      line-height: 1;
      cursor: pointer;
      -webkit-appearance: none;
      appearance: none;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__button {
      display: flex;
      grid-column: 3;
      grid-row: 1 / 4;
      align-self: center;
      align-items: center;
      justify-content: center;
      flex: 0 0 40px;
      min-width: 40px;
      width: 40px;
      min-height: 40px;
      height: 40px;
      padding: 0;
      border-radius: 6px;
      background: transparent;
      border: 0;
      font-family: inherit;
    }
    .hl-cart-upsells + .cart-addons-v1--inline .cart-addons-v1__button-icon {
      display: block;
      width: 32px;
      height: 32px;
    }
    .cart-addons-v1__button[disabled] {
      cursor: default;
      opacity: 0.68;
    }
    .cart-addons-v1__select {
      width: 100%;
      margin: 7px 0 0;
      min-height: 34px;
      border: 1px solid rgba(37, 57, 99, 0.18);
      border-radius: 6px;
      background: #fff;
      color: #000;
      font-size: 12px;
    }
    .cart-addons-v1__cart-line {
      animation: cart-addons-v1-fade-in 0.18s ease;
    }
    @keyframes cart-addons-v1-fade-in {
      from { opacity: 0; transform: translateY(-4px); }
      to { opacity: 1; transform: translateY(0); }
    }
    #cd-opus-scroll-effect > .cd-app-scroll-list > .cdr-main-color.scrollbar-hide > .announcement:first-child {
      padding-top: 8px !important;
      padding-bottom: 8px !important;
      font-size: 12px !important;
    }
    #cd-opus-scroll-effect > .cd-app-scroll-list > .cdr-main-color.scrollbar-hide > .announcement:first-child > p {
      font-size: 12px !important;
    }
    #cd-opus-scroll-effect > .cd-app-scroll-list > .cdr-main-color.scrollbar-hide:first-child {
      background: #f5f6f7 !important;
    }
    .cd-upsell-title em {
      font-style: normal !important;
    }
    #cart-drawer-container > div[class*="drawer-cd-up-app-"].right > div[class*="header"]:first-child {
      background: #fff !important;
    }
    #cd-opus-scroll-effect > .cd-app-scroll-list > .bottom-section {
      background: #fff !important;
    }
  `;

  function request(url, options) {
    options = options || {};

    if (window.fetch) {
      return fetch(url, Object.assign({
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }, options)).then(response => response.json());
    }

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Accept', 'application/json');
      Object.keys(options.headers || {}).forEach(key => xhr.setRequestHeader(key, options.headers[key]));
      xhr.onload = () => resolve(JSON.parse(xhr.responseText));
      xhr.onerror = reject;
      xhr.send(options.body || null);
    });
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents);
    }

    return (cents / 100).toLocaleString('da-DK', {
      style: 'currency',
      currency: window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'DKK'
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function imageUrl(url) {
    if (!url) return '';
    return String(url).startsWith('//') ? `${window.location.protocol}${url}` : String(url);
  }

  function cart() {
    if (currentCart) return Promise.resolve(currentCart);
    return request('/cart.js').then(data => {
      currentCart = data;
      return data;
    });
  }

  function cartHasBottle(cartData) {
    return Boolean(cartData && cartData.items && cartData.items.some(item => {
      const productId = Number(item.product_id || (item.product && item.product.id) || 0);
      const handle = String(item.handle || item.product_handle || '').toLowerCase();
      return BOTTLE_PRODUCT_IDS.includes(productId) || BOTTLE_HANDLES.includes(handle);
    }));
  }

  function setBottleUpsellsVisibility(root, visible, hasAddonUpsell) {
    const carousel = root.querySelector('.opus-carousel-container, .hl-cart-upsells');
    if (!carousel) return;

    const hasNativeUpsell = !carousel.matches('.hl-cart-upsells') || Boolean(carousel.querySelector('.hl-cart-upsell-card'));
    carousel.hidden = !visible || (!hasNativeUpsell && !hasAddonUpsell);
  }

  function loadAddonProducts() {
    if (addonProducts) return Promise.resolve(addonProducts);
    if (addonProductsLoading) return addonProductsLoading;

    addonProductsLoading = Promise.all(ADDON_PRODUCTS.map(config => {
      if (!config.handle) return Promise.resolve(null);

      return request(`/products/${config.handle}.js`)
        .then(product => Object.assign({}, config, { product: product }))
        .catch(error => {
          console.warn('[cart-addons-v1] product unavailable', config.handle, error);
          return null;
        });
    })).then(products => {
      addonProducts = products.filter(Boolean);
      return addonProducts;
    });

    return addonProductsLoading;
  }

  function addVariant(variantId) {
    return request('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: { [variantId]: 1 } })
    }).then(data => {
      currentCart = data;
      return data;
    });
  }

  function setQuantity(quantity) {
    return request('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: { [VARIANT_ID]: quantity } })
    }).then(data => {
      currentCart = data;
      return data;
    });
  }

  function roots() {
    const list = [document];
    document.querySelectorAll('#opus-shadow-container').forEach(host => {
      if (host.shadowRoot) list.push(host.shadowRoot);
    });
    return list;
  }

  function addStyle(root) {
    const existing = root.querySelector(`#${STYLE_ID}`);
    if (existing) {
      if (existing.textContent !== styles) existing.textContent = styles;
      return;
    }

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = styles;
    (root === document ? document.head : root).appendChild(style);
  }

  function neutralizeOld(root) {
    root.querySelectorAll(OLD_SELECTOR).forEach(node => {
      if (node.getAttribute('data-cart-protection-sentinel') === 'true') return;
      node.remove();
    });

    if (!root.querySelector('[data-cart-protection-sentinel="true"]')) {
      const sentinel = document.createElement('span');
      sentinel.hidden = true;
      sentinel.style.display = 'none';
      sentinel.setAttribute('data-cart-protection-toggle', '');
      sentinel.setAttribute('data-cart-protection-sentinel', 'true');
      (root.body || root).appendChild(sentinel);
    }
  }

  function card() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cart-protection-v2';
    button.setAttribute('data-cart-protection-v2', '');
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML = `
      <span class="cart-protection-v2__switch" aria-hidden="true"><span class="cart-protection-v2__knob"></span></span>
      <span class="cart-protection-v2__icon" aria-hidden="true">
        <svg viewBox="0 0 293 272" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M114.642 268.811L18.582 213.852C6.77136 207.081 0 200.309 0 180.625V85.5094C0 71.1789 5.03916 62.2028 16.8498 55.4314L101.099 7.08644C117.634 -2.36215 133.224 -2.36215 149.76 7.08644L234.009 55.4314C245.662 62.2028 250.859 71.1789 250.859 85.5094V101.806C250.859 101.806 250.859 112.274 240.229 112.274C229.6 112.274 229.6 101.806 229.6 101.806V89.9187L136.531 143.775V243.3L182.393 216.874C182.393 216.874 191.945 211.309 197.487 220.908C203.028 230.507 193.434 235.996 193.434 235.996L136.059 268.811C128.815 273.063 122.044 273.063 114.642 268.811ZM21.2592 179.995C21.2592 186.924 23.9363 191.176 30.7078 195.113L114.327 243.3V143.775L21.2592 89.9187V179.995ZM33.6997 71.6514L125.351 124.091L160.153 104.091L68.6595 51.3371L33.6997 71.6514ZM90.7059 38.7389L182.829 91.1784L217.159 71.6514L140.783 27.7158C130.232 21.4169 120.627 21.5742 109.918 27.7158L90.7059 38.7389Z" fill="currentColor"/>
          <path d="M250.604 225.754V140.582C250.604 133.965 246.232 129.319 239.81 129.319C233.525 129.319 229.426 133.965 229.426 140.582V225.754C229.426 232.23 233.525 236.876 239.81 236.876C246.232 236.876 250.604 232.23 250.604 225.754ZM198.684 194.079H281.347C287.632 194.079 292.141 189.714 292.141 183.238C292.141 176.622 287.632 172.117 281.347 172.117H198.684C192.262 172.117 187.89 176.622 187.89 183.238C187.89 189.714 192.262 194.079 198.684 194.079Z" fill="currentColor"/>
        </svg>
      </span>
      <span class="cart-protection-v2__text">
        <span class="cart-protection-v2__title">Pakke forsikring &amp; ekspress levering</span>
        <span class="cart-protection-v2__description">Beskyttelse mod skader, tab, tyveri og mere!</span>
      </span>
    `;
    button.addEventListener('click', onClick);
    return button;
  }

  function syncProtectionButton(root) {
    const button = root.querySelector(SELECTOR);
    if (!button || button.classList.contains('is-loading')) return;

    cart().then(cartData => {
      const enabled = Boolean(cartData && cartData.items && cartData.items.some(item => {
        return Number(item.variant_id) === VARIANT_ID && Number(item.quantity || 0) > 0;
      }));
      button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
    });
  }

  function availableAddonProducts(products, cartData) {
    return products.filter(item => {
      const variants = (item.product && item.product.variants) || [];
      const inCart = cartData.items && cartData.items.some(cartItem => {
        return variants.some(variant => Number(variant.id) === Number(cartItem.variant_id));
      });
      return !inCart && variants.some(variant => variant.available);
    });
  }

  function addonPanel(products, cartData, options) {
    options = options || {};
    const availableProducts = availableAddonProducts(products, cartData);

    if (!availableProducts.length) return null;

    const panel = document.createElement('section');
    panel.className = `cart-addons-v1${options.inline ? ' cart-addons-v1--inline' : ''}`;
    panel.setAttribute('data-cart-addons-v1', '');
    if (!options.inline) {
      panel.innerHTML = '<h3 class="cart-addons-v1__title">Mange køber også</h3>';
    }

    availableProducts.slice(0, 2).forEach(item => {
      const product = item.product;
      const displayTitle = item.title || product.title;
      const variants = product.variants.filter(variant => variant.available);
      const firstVariant = variants[0];
      const image = product.featured_image || (product.images && product.images[0]) || '';
      const line = document.createElement('article');
      line.className = 'cart-addons-v1__item';
      line.innerHTML = `
        <img class="cart-addons-v1__image" src="${imageUrl(image)}" alt="">
        <div class="cart-addons-v1__content">
          <div class="cart-addons-v1__heading">
            <span class="cart-addons-v1__name">${escapeHtml(displayTitle)}</span>
            ${item.badge ? `<span class="cart-addons-v1__badge">${item.badge}</span>` : ''}
          </div>
          ${item.description ? `<p class="cart-addons-v1__description">${item.description}</p>` : ''}
          <div class="cart-addons-v1__row">
            <span class="cart-addons-v1__price">${formatMoney(firstVariant.price)}${firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price ? `<span class="cart-addons-v1__compare">${formatMoney(firstVariant.compare_at_price)}</span>` : ''}</span>
            <button
              type="button"
              class="cart-addons-v1__button"
              data-cart-addon-add
              aria-label="Tilføj ${escapeHtml(displayTitle)}"
            >${ADD_BUTTON_ICON}</button>
          </div>
        </div>
      `;

      if (variants.length > 1) {
        const select = document.createElement('select');
        select.className = 'cart-addons-v1__select';
        select.setAttribute('aria-label', 'Vælg variant');
        variants.forEach(variant => {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title;
          select.appendChild(option);
        });
        line.querySelector('.cart-addons-v1__content').appendChild(select);
      }

      const button = line.querySelector('[data-cart-addon-add]');
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const select = line.querySelector('.cart-addons-v1__select');
        const variantId = select ? select.value : firstVariant.id;
        button.disabled = true;
        button.textContent = '…';
        button.setAttribute('aria-label', 'Tilføjer');

        addVariant(variantId)
          .then(updatedCart => {
            button.textContent = '✓';
            button.setAttribute('aria-label', 'Tilføjet');
            refresh(updatedCart);
            window.setTimeout(() => ensureAddonLineVisible(item, firstVariant, updatedCart), 450);
            schedule();
          })
          .catch(error => {
            console.warn('[cart-addons-v1] add failed', error);
            button.disabled = false;
            button.innerHTML = ADD_BUTTON_ICON;
            button.setAttribute('aria-label', `Tilføj ${displayTitle}`);
          });
      });

      panel.appendChild(line);
    });

    return panel;
  }

  function refresh(cart) {
    const detail = { cart: cart };
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:build', { detail: detail }));

    [
      'OpusCartChange',
      'OpusSetCartData',
      'OpusAddToCartComplete'
    ].forEach(name => {
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
      window.dispatchEvent(new CustomEvent(name, { detail: detail }));
    });
  }

  function ensureAddonLineVisible(item, variant, cartData) {
    const product = item.product;
    const lineItem = cartData.items && cartData.items.find(cartItem => Number(cartItem.variant_id) === Number(variant.id));
    if (!lineItem) return;

    roots().forEach(root => {
      const productList = root.querySelector('.cd-product-list');
      if (!productList) return;

      const alreadyVisible = Array.from(productList.querySelectorAll('.cd-product-item-title, .cd-product-item')).some(node => {
        return (node.innerText || node.textContent || '').includes(product.title);
      });
      if (alreadyVisible) return;

      const line = document.createElement('div');
      line.className = 'cd-product-item cart-addons-v1__cart-line';
      line.setAttribute('data-cart-addon-line-v1', String(variant.id));
      line.innerHTML = `
        <div class="cd-product-item-content">
          <div class="cd-product-item-image-container">
            <img alt="${escapeHtml(product.title)}" src="${imageUrl(lineItem.image || product.featured_image || (product.images && product.images[0]))}" loading="lazy" class="cd-product-item-image">
          </div>
          <div class="cd-product-item-details">
            <div class="cd-product-item-header">
              <div class="cd-product-item-title-container">
                <a href="${escapeHtml(product.url || `/products/${product.handle}?variant=${variant.id}`)}" class="cd-product-item-title">${escapeHtml(product.title)}</a>
              </div>
            </div>
            <div class="cd-product-item-price-wrapper">
              <div class="cd-number-input-container">
                <div class="cd-section-price">
                  <div class="opus-product-price-section">
                    <div class="cd-price-display">
                      <span class="money opus-money">${formatMoney(lineItem.final_line_price || variant.price)}</span>
                    </div>
                  </div>
                </div>
                <div class="cd-number-input">
                  <button class="cd-number-input-button" type="button" disabled>-</button>
                  <input max="1" class="cd-number-input-field" value="1" disabled>
                  <button class="cd-number-input-button" type="button" disabled>+</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      productList.insertBefore(line, productList.firstChild);
    });
  }

  function onClick(event) {
    const button = event.currentTarget;
    if (!button || button.classList.contains('is-loading')) return;

    const enable = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', enable ? 'true' : 'false');
    button.classList.add('is-loading');
    button.disabled = true;

    setQuantity(enable ? 1 : 0)
      .then(cart => {
        refresh(cart);
      })
      .catch(error => {
        currentCart = null;
        button.setAttribute('aria-pressed', enable ? 'false' : 'true');
        console.warn('[cart-protection-v2] update failed', error);
      })
      .finally(() => {
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  }

  function findCheckout(root) {
    return Array.from(root.querySelectorAll('button, a, [role="button"], .opus-btn-checkout, .opus-checkout-btn-2')).find(el => {
      const text = (el.innerText || el.textContent || '').toLowerCase();
      const classes = String(el.className || '').toLowerCase();
      return text.includes('gå til betaling') || text.includes('checkout') || classes.includes('opus-btn-checkout') || classes.includes('opus-checkout-btn');
    });
  }

  function findUpsellSlot(root) {
    const carousel = root.querySelector('.opus-carousel-container, .hl-cart-upsells');
    if (!carousel) return null;

    return {
      target: carousel.parentNode,
      after: carousel,
      inline: true
    };
  }

  function renderAddons(root, slot) {
    if (!slot) return;

    Promise.all([loadAddonProducts(), cart()]).then(([products, cartData]) => {
      const existingPanel = root.querySelector(ADDONS_SELECTOR);
      const showBottleUpsells = cartHasBottle(cartData);
      const hasAddonUpsell = availableAddonProducts(products, cartData).length > 0;
      setBottleUpsellsVisibility(root, showBottleUpsells, hasAddonUpsell);
      if (!showBottleUpsells) {
        if (existingPanel) existingPanel.remove();
        return;
      }
      if (!hasAddonUpsell) {
        if (existingPanel) existingPanel.remove();
        return;
      }
      if (existingPanel) return;
      const panel = addonPanel(products, cartData, { inline: slot.inline });
      if (!panel || !slot.target) return;

      if (slot.after && slot.after.parentNode) {
        slot.after.parentNode.insertBefore(panel, slot.after.nextSibling);
      } else if (slot.before) {
        slot.target.insertBefore(panel, slot.before);
      } else {
        slot.target.appendChild(panel);
      }
    });
  }

  function render() {
    roots().forEach(root => {
      addStyle(root);
      neutralizeOld(root);
      let protection = root.querySelector(SELECTOR);

      const footer = root.querySelector('.bottom-section');
      if (footer) {
        if (!protection) protection = card();
        if (protection.parentNode !== footer || footer.firstChild !== protection) {
          footer.insertBefore(protection, footer.firstChild);
        }
      }

      const nativeFooter = root.querySelector('.hl-cart-drawer__footer');
      const nativeTotal = nativeFooter && nativeFooter.querySelector('.hl-cart-drawer__total');
      if (!footer && nativeFooter) {
        if (!protection) protection = card();
        const nativeInsertBefore = nativeTotal || nativeFooter.firstChild;
        const isInNativePosition = protection.parentNode === nativeFooter && (
          nativeInsertBefore === protection || protection.nextSibling === nativeInsertBefore
        );
        if (!isInNativePosition) {
          nativeFooter.insertBefore(protection, nativeInsertBefore);
        }
      }

      if (protection) syncProtectionButton(root);

      const checkout = findCheckout(root);
      const checkoutTarget = checkout && (checkout.closest('.opus-btn-checkout, .opus-checkout-btn-2, button, a, [role="button"]') || checkout);
      if (!footer && !nativeFooter && !protection && checkoutTarget && checkoutTarget.parentNode) {
        protection = card();
        checkoutTarget.parentNode.insertBefore(protection, checkoutTarget);
      }

      const upsellSlot = findUpsellSlot(root);
      if (upsellSlot) {
        renderAddons(root, upsellSlot);
        return;
      }

      if (footer) {
        renderAddons(root, { target: footer, before: protection || footer.firstChild, inline: false });
        return;
      }

      const target = checkoutTarget;
      if (target && target.parentNode) {
        renderAddons(root, { target: target.parentNode, before: protection || target, inline: false });
      }
    });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(render, 100);
  }

  function refreshAddons(event) {
    const eventCart = event && event.detail && event.detail.cart;
    if (eventCart && eventCart === lastRefreshCart) return;

    if (eventCart) {
      lastRefreshCart = eventCart;
      currentCart = eventCart;
      roots().forEach(root => {
        const existingPanel = root.querySelector(ADDONS_SELECTOR);
        if (existingPanel) existingPanel.remove();
      });
    } else {
      lastRefreshCart = null;
      currentCart = null;
    }

    schedule();
  }

  new MutationObserver(records => {
    const cartMarkupAdded = records.some(record => {
      return Array.from(record.addedNodes || []).some(node => {
        return node.nodeType === 1 && (
          (node.matches && node.matches('.hl-cart-items')) ||
          (node.querySelector && node.querySelector('.hl-cart-items'))
        );
      });
    });

    if (cartMarkupAdded) {
      window.clearTimeout(timer);
      render();
      return;
    }

    schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:updated', refreshAddons);
  window.addEventListener('OpusCartChange', refreshAddons);
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  schedule();
  window.setTimeout(schedule, 1000);
  window.setTimeout(schedule, 3000);
})();
